var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"is-relative ziel"},[_c('div',{staticClass:"container has-text-centerd has-text-weight-semibold"},[_c(_vm.ziel_name,{tag:"component"}),_vm._v(" "),_c('div',{staticClass:"has-text-centered is-size-5-tablet"},[_vm._v(_vm._s(_vm.ziel_text))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }